import { all, call, put } from 'redux-saga/effects';
import { CommentsTypes as Types } from '../ducks/comments';
import { CourseTypes } from '../ducks/course';
import { sagaErrorHandle } from './sagasError';
import {
  listAllRequest,
  listByLessonRequest,
  storeRequest,
  updateRequest,
  removeRequest,
} from '../../services/comments';
import { convertArrToObj } from '../../utils';

export function* listStudentComments() {
  yield put({ type: Types.SET_STUDENT_COMMENTS_FAILURE, errorData: null });
  try {
    const { data: comments } = yield call(listAllRequest);
    yield put({
      type: Types.SET_STUDENT_COMMENTS,
      comments: comments ? convertArrToObj(comments, 'id') : {},
    });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'listStudentComments',
      errorData: error,
    });
    yield put({
      type: Types.SET_STUDENT_COMMENTS_FAILURE,
      errorData: { status, msg },
    });
  }
}

export function* listLessonComments({ courseId, lessonId }) {
  try {
    const { data: comments } = yield call(listByLessonRequest, {
      courseId,
      lessonId,
    });
    const payload = {
      courseId,
      lessonId,
      comments: comments ? convertArrToObj(comments, 'id') : {},
    };
    yield put({ type: CourseTypes.SET_LESSON_COMMENTS, ...payload });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'listLessonComments',
      errorData: error,
      additionalInfos: { courseId, lessonId },
    });
    yield put({
      type: Types.LESSON_COMMENTS_FAILURE,
      errorData: { status, msg },
      courseId,
      lessonId,
    });
  }
}

export function* storeComment(action) {
  const { courseId, lessonId, parentId, description } = action;
  const commentData = {
    description,
    parentId,
  };
  try {
    const { data } = yield call(storeRequest, {
      courseId,
      lessonId,
      commentData,
    });
    const comments = { [data.id]: data };
    yield put({ type: Types.UPDATE_STUDENT_COMMENTS, comments });
    yield put({
      type: CourseTypes.UPDATE_LESSON_COMMENTS,
      comments,
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    yield sagaErrorHandle({
      sagaName: 'storeComment',
      errorData: error,
      additionalInfos: action,
    });
    // console.log('errorData getCourse', error.response);
    // yield put({ type: Types.FAILURE_LOGIN, errorData });
  }
}

export function* updateComment(action) {
  const { courseId, lessonId, commentId, description } = action;
  const commentData = { description };

  try {
    const { data: comment } = yield call(updateRequest, {
      courseId,
      lessonId,
      commentId,
      commentData,
    });
    const comments = { [comment.id]: comment };
    yield put({ type: Types.UPDATE_STUDENT_COMMENTS, comments });
    yield put({
      type: CourseTypes.UPDATE_LESSON_COMMENTS,
      comments,
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    yield sagaErrorHandle({
      sagaName: 'updateComment',
      errorData: error,
      additionalInfos: action,
    });
    // console.log('errorData getCourse', error.response);
    // yield put({ type: Types.FAILURE_LOGIN, errorData });
  }
}

export function* removeComment(action) {
  const { courseId, lessonId, commentId } = action;
  try {
    yield call(removeRequest, { courseId, lessonId, commentId });
    yield all([
      put({ type: Types.REMOVE_STUDENT_COMMENT, commentId }),
      put({
        type: CourseTypes.REMOVE_LESSON_COMMENT,
        commentId,
        course: courseId,
        lesson: lessonId,
      }),
    ]);
  } catch (error) {
    yield sagaErrorHandle({
      sagaName: 'removeComment',
      errorData: error,
      additionalInfos: action,
    });
    // console.log('errorData getCourse', error.response);
    // yield put({ type: Types.FAILURE_LOGIN, errorData });
  }
}
